export default {
    data: () => ({
        menuItems: [
            {
                icon: 'dashboard',
                label: 'dashboard',
                route: 'home'
            },

            // Backoffice
            {
                label: 'lending points',
                icon: 'store',
                route: 'backoffice.lending-point.index',
                widget: true,
                role: ['Admin', 'Backoffice', 'Lending Point Backoffice']
            },
            {
                label: 'Stock Management',
                icon: 'store',
                route: 'backoffice.stock-management.index',
                widget: true,
                role: ['Admin', 'Backoffice', 'Lending Point Backoffice']
            },
            {
                label: 'orders',
                icon: 'shopping cart',
                route: 'backoffice.order.index',
                widget: true,
                role: ['Admin', 'Backoffice']
            },
           /* {
                label: 'Change Order Status to Completed Not Returned',
                icon: 'save',
                route: 'backoffice.order.change-status.completed-not-returned',
                widget: true,
                prod_env: false,
                role: ['Admin', 'Backoffice']
            },*/
            {
                label: 'lending kits',
                icon: 'how to vote',
                route: 'backoffice.lending-kit.index',
                widget: true,
                role: ['Admin', 'Backoffice']
            },

            {
                label: 'IQOS - lending kits upload',
                icon: 'how to vote',
                route: 'backoffice.lending-kit-upload.index',
                widget: true,
                role: ['Admin', 'Backoffice']
            },
            {
                label: 'stock movements',
                icon: 'compare arrows',
                route: 'backoffice.stock-movement.index',
                widget: true,
                role: ['Admin', 'Backoffice']
            },
            {
                label: 'order movements',
                icon: 'compare arrows',
                route: 'backoffice.order-movement.index',
                widget: true,
                role: ['Admin', 'Backoffice']
            },
            {
                label: 'pick-up / delivery stock order',
                icon: 'compare arrows',
                route: 'backoffice.stock-order',
                widget: true,
                role: ['Backoffice']
            },
            {
                label: 'stock orders history',
                icon: 'shopping_cart',
                route: 'backoffice.stock-orders',
                widget: true,
                role: ['Backoffice', 'Admin'],
            },
            {
                label: 'users',
                icon: 'people',
                route: 'backoffice.user.index',
                widget: true,
                role: 'Backoffice'
            },
            {
                label: 'lending kit model',
                icon: 'how to vote',
                route: 'backoffice.lending-kit-model.index',
                widget: true,
                role: ['Admin', 'Backoffice']
            },
            {
                label: 'lending kit color',
                icon: 'how to vote',
                route: 'backoffice.lending-kit-color.index',
                widget: true,
                role: ['Admin', 'Backoffice']
            },
            {
                label: 'Lendings in Dunning',
                icon: 'how to reg',
                route: 'orders.in-dunning',
                widget: true,
                role: ['Reverse Dunning Process', 'Admin', 'Backoffice'],
            },

            // Call Center
            {
                label: 'create a new lending order',
                icon: 'note add',
                route: 'call-center.order',
                widget: true,
                role: 'Call Center',
            },
            {
                label: 'orders history',
                icon: 'shopping_cart',
                route: 'call-center.orders',
                widget: true,
                role: ['Call Center'],
            },
            {
                label: 'lendings > 15 days',
                icon: 'alarm off',
                route: 'call-center.orders.due',
                widget: true,
                role: 'Call Center',
            },
            {
                label: 'lendings > 30 days',
                icon: 'alarm off',
                route: 'call-center.orders.more-than-30',
                widget: true,
                role: 'Call Center',
            },
            {
                label: 'lendings that will due',
                icon: 'alarm',
                route: 'call-center.orders.will-due',
                widget: true,
                role: 'Call Center',
            },
            {
                label: 'orders closed before 15 days',
                icon: 'history',
                route: 'call-center.orders.closed-earlier',
                widget: true,
                role: 'Call Center',
            },
            {
                label: 'consumer registration',
                icon: 'face',
                route: 'call-center.consumer-registration',
                widget: true,
                role: 'Call Center',
            },
            {
                label: 'lending kits',
                icon: 'how to vote',
                route: 'call-center.lending-kit.index',
                widget: true,
                role: 'Call Center',
            },
            {
                label: 'lending points',
                icon: 'store',
                route: 'call-center.lending-point.index',
                widget: true,
                role: 'Call Center',
            },

            // Lending Point
            {
                label: 'create a new lending order',
                icon: 'note add',
                route: 'lending-point.order',
                widget: true,
                role: ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'],
                mustBeActive: 1
            },
            {
                label: 'reports',
                icon: 'assignment',
                route: 'lending-point.reports',
                widget: true,
                mustBeActive: 1,
                role: ['Lending Point', 'Lending Point Indirect'],
                children: [
                    {
                        label: 'orders history',
                        icon: 'shopping_cart',
                        route: 'lending-point.orders',
                        widget: true,
                        role: ['Lending Point', 'Lending Point Indirect'],
                    },
                    {
                        label: 'orders in lending',
                        icon: 'how to reg',
                        route: 'lending-point.orders.in-lending',
                        widget: true,
                        role: ['Lending Point', 'Lending Point Indirect'],
                        mustBeActive: 1
                    },
                    {
                        label: 'lending kits stock',
                        icon: 'how to vote',
                        route: 'lending-point.lending-kits',
                        widget: true,
                        role: ['Lending Point', 'Lending Point Indirect'],
                        mustBeActive: 1
                    },
                    {
                        label: 'lending kits for maintenance',
                        icon: 'phonelink_setup',
                        route: 'lending-point.lending-kits.cleaning',
                        widget: true,
                        role: ['Lending Point', 'Lending Point Indirect'],
                        mustBeActive: 1
                    },
                ]
            },
            {
                label: 'good receipt',
                icon: 'move_to_inbox',
                route: 'lending-point.stock-order.good-receipt',
                widget: true,
                role: ['Lending Point', 'Lending Point Indirect'],
                mustBeActive: 1
            },
            {
                label: 'ending lending',
                icon: 'assignment late',
                route: 'lending-point.ending-lending',
                widget: true,
                role: ['Lending Point', 'Lending Point Indirect'],
                mustBeActive: 1
            },
            {
                label: 'call center reserved orders',
                icon: 'star',
                route: 'lending-point.orders.reserved',
                widget: true,
                role: ['Lending Point', 'Lending Point Indirect'],
                mustBeActive: 1,
                mustBeReserveAllowed: 1
            },

            //Lending Point Hostesses
            {
                label: 'orders history',
                icon: 'shopping_cart',
                route: 'lending-point-hostesses.orders',
                widget: true,
                role:  'Lending Point Hostesses',
                mustBeActiveHostless: 1
            },
            {
                label: 'lending kits stock',
                icon: 'how to vote',
                route: 'lending-point.lending-kits',
                widget: true,
                role:  'Lending Point Hostesses',
                mustBeActiveHostless: 1
            },
            {
                label: 'good receipt',
                icon: 'move_to_inbox',
                route: 'lending-point.stock-order.good-receipt',
                widget: true,
                role:  'Lending Point Hostesses',
                mustBeActiveHostless: 1
            },
    
            // Iqos Coach
            {
                label: 'create a new lending order',
                icon: 'note add',
                route: 'iqos-coach.order',
                widget: true,
                role: 'Iqos Coach',
            },
            {
                label: 'orders history',
                icon: 'shopping_cart',
                route: 'iqos-coach.orders',
                widget: true,
                role: 'Iqos Coach',
            },
            {
                label: 'orders in lending',
                icon: 'how to reg',
                route: 'iqos-coach.orders.in-lending',
                widget: true,
                role: 'Iqos Coach',
            },
            {
                label: 'lending kits stock',
                icon: 'how to vote',
                route: 'iqos-coach.lending-kits',
                widget: true,
                role: 'Iqos Coach'
            },
            {
                label: 'pending pickup orders',
                icon: 'undo',
                route: 'iqos-coach.orders.pending-pickup',
                widget: true,
                role: 'Iqos Coach',
            },
            {
                label: 'lending kits for maintenance',
                icon: 'phonelink_setup',
                route: 'iqos-coach.lending-kits.cleaning',
                widget: true,
                role: 'Iqos Coach'
            },
            {
                label: 'good receipt',
                icon: 'move_to_inbox',
                route: 'iqos-coach.stock-order.good-receipt',
                widget: true,
                role: 'Iqos Coach',
            },


            // Courier

            //Courier Only

            {
                label: 'delivery orders',
                icon: 'star',
                route: 'courier.orders.reserved',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier'
            },
            {
                label: 'in transit - delivery',
                icon: 'motorcycle',
                route: 'courier.orders.in-transit-delivery',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier'
            },
            {
                label: 'pending pickup orders',
                icon: 'undo',
                route: 'courier.orders.pending-pickup',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier'
            },
            {
                label: 'in transit - pickup',
                icon: 'motorcycle',
                route: 'courier.orders.in-transit-pickup',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier'
            },

            {
                label: 'orders history',
                icon: 'shopping_cart',
                route: 'courier.orders',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier'

            },
            // Courier - Retail
            {
                label: 'delivery orders',
                icon: 'star',
                route: 'courier.stock-orders.pending-delivery',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier - Retail'
            },
            {
                label: 'pending pickup orders',
                icon: 'undo',
                route: 'courier.stock-orders.pending-pickup',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier - Retail'
            },
            {
                label: 'in transit - delivery',
                icon: 'motorcycle',
                route: 'courier.stock-orders.in-transit.delivery',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier - Retail'
            },
            {
                label: 'in transit - pickup',
                icon: 'motorcycle',
                route: 'courier.stock-orders.in-transit.pickup',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier - Retail'
            },
            {
                label: 'available lending kits',
                icon: 'phonelink_setup',
                route: 'courier.lending-kits.available',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier - Retail'
            },
            {
                label: 'lending kits for maintenance',
                icon: 'phonelink_setup',
                route: 'courier.lending-kits.cleaning',
                widget: true,
                role: 'Courier'
            },

            {
                label: 'stock orders history',
                icon: 'shopping_cart',
                route: 'courier.stock-orders',
                widget: true,
                role: 'Courier',
                lendingPointRole: 'Courier - Retail'
            },
            {
                label: 'broken lending kits',
                icon: 'how to vote',
                route: 'courier.lending-kits.broken',
                widget: true,
                role: 'Courier'
            },
            {
                label: 'lending kits stock',
                icon: 'how to vote',
                route: 'courier.lending-kits',
                widget: true,
                role: 'Courier'
            },

            // Audit

            {
                label: 'stock orders history',
                icon: 'shopping_cart',
                route: 'audit.stock-orders',
                widget: true,
                role: [ 'Retail Call Center'],
            },


            // Admin
            {
                label: 'reference tables',
                icon: 'format_list_numbered',
                role: 'Admin',
                children: [
                    {
                        label: 'lending point types',
                        icon: 'place',
                        route: 'admin.lending-point-type.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'consumer types',
                        icon: 'people',
                        route: 'admin.consumer-type.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'no sold reasons',
                        icon: 'not_interested',
                        route: 'admin.no-sold-reason.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'order statuses',
                        icon: 'label',
                        route: 'admin.order-status.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'origins',
                        icon: 'input',
                        route: 'admin.origin.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'stock statuses',
                        icon: 'archive',
                        route: 'admin.stock-status.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'stock order statuses',
                        icon: 'archive',
                        route: 'admin.stock-order-status.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'stock operation',
                        icon: 'archive',
                        route: 'admin.stock-operation.index',
                        widget: true,
                        role: 'Admin'
                    }
                ]
            },
            {
                label: 'Order Error DCS',
                icon: 'how to vote',
                route: 'backoffice.order-error-dcs.index',
                widget: true,
                role: ['Admin', 'Backoffice']
            },
            {
                label: 'Stock Orders Report',
                icon: 'how to vote',
                route: 'backoffice.stock-order-change-status.index',
                widget: true,
                role: ['Admin', 'Backoffice']
            },
            {
                label: 'api token',
                icon: 'settings',
                route: 'admin.personal-access-token.index',                
                role: ['Admin']
            },
            {
                label: 'adminstrative tools',
                icon: 'security',
                role: 'Admin',
                children: [
                    {
                        label: 'roles',
                        icon: 'pan_tool',
                        route: 'admin.role.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'users',
                        icon: 'people',
                        route: 'admin.user.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'configuration',
                        icon: 'settings',
                        route: 'admin.configuration.index',
                        widget: true,
                        role: 'Admin'
                    },
                    {
                        label: 'audit',
                        icon: 'lock',
                        route: 'admin.audit.index',
                        widget: true,
                        widgetType: 'line',
                        role: 'Admin'
                    },
                    {
                        label: 'sent sms',
                        icon: 'question_answer',
                        route: 'admin.sent-sms.index',
                        widget: true,
                        widgetType: 'line',
                        role: 'Admin'
                    },
                    {
                        label: 'email templates',
                        icon: 'email',
                        route: 'admin.email-template.index',
                        widget: true,
                        widgetType: 'line',
                        role: 'Admin'
                    },
                    {
                        label: 'sms templates',
                        icon: 'sms',
                        route: 'admin.sms-template.index',
                        widget: true,
                        widgetType: 'line',
                        role: 'Admin'
                    },
                    {
                        label: 'whitelist',
                        icon: 'list',
                        route: 'admin.whitelist.index',
                        widget: true,
                        widgetType: 'line',
                        role: 'Admin'
                    },
                    {
                        label: 'change devices email',
                        icon: 'how to vote',
                        route: 'admin.change-device-email.index',
                        widget: true,
                        widgetType: 'line',
                        role: 'Admin'
                    }
                ]
            }
        ]
    })

}



// WEBPACK FOOTER //
// ./resources/assets/js/menuItems.js